import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment.prod';
import { RequestServiceService } from 'src/app/core/services/request-service/request-service.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { MessagesService } from 'src/app/core/services/messages/messages.service';
import { SocialAuthService, SocialUser } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
declare var google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  incorrect: boolean = false;
  message: any;
  pwdType: any = true;
  private auth2: any;
  isType: boolean = false;
  constructor(
    private route: ActivatedRoute, private formBuilder: FormBuilder, private ngZone: NgZone, private authServices: SocialAuthService,
    private router: Router, private requestApiService: RequestServiceService, private authService: AuthService, private messageservices: MessagesService
  ) {
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: ['', [Validators.required, Validators.minLength(5)]]
    });
    //google.accounts.id.initialize({
    //   client_id: '949545769449-2crql0mqd0geu3mjf9qot9lgd0e96cma.apps.googleusercontent.com',
    //   callback: this.handleCredentialResponse
    // });
    // google.accounts.id.renderButton(
    //   document.getElementById("buttonDiv"),
    //   { theme: "outline", size: "large" }  // customization attributes
    // );
    // google.accounts.id.prompt();
  }
  handleCredentialResponse(response: any) {
    //console.log("Encoded JWT ID token: " + response.credential);
  }
  async signInWithGoogle() {
    try {
      const socilResp = await this.authServices.signIn(
        GoogleLoginProvider.PROVIDER_ID
      );
      if (socilResp && socilResp.id) {
        //console.log(socilResp)
        this.requestApiService.socialLogin({ email: socilResp.email, id_token: socilResp.authToken, login_type: 'google' }).then(response => {

          if (response.success) {
            localStorage.setItem('res_uid', response.data.res_id)
            localStorage.setItem('seat_allocated', response.data.max_guest_per_slot)
            localStorage.setItem('guest_per_booking', response.data.max_guest_per_booking)
            localStorage.setItem('force_update_pass', response.data.user.force_update_pass)
            this.incorrect = false;
            this.message = response.message;
            this.messageservices.showNotification(response.msg, 'success', 'success');
            if (response.data.user.res_name)
              this.requestApiService.setRestaurantInfoSubmitted(true);
            this.authService.setAuthInfo(response);
            this.router.navigate(['/dashboard']);
          } else {
            this.incorrect = true;
            this.message = response.message;
            //console.log(response.message);
            this.messageservices.showNotification(response.msg, 'error', 'error');
          }
        });
      } else {
        // TODO SHow Error message
      }
    } catch (err) {
      //console.log(err);
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const param1 = params['type'];
      if (param1 == 'app') {
        this.isType = true
      }
    })
  }

  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.incorrect = false;

    const loginParam = {
      email: this.registerForm.value.email,
      password: this.registerForm.value.password
    };

    // Stop here if the form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // Uncomment and replace with your service call
    this.requestApiService.login(loginParam).then(response => {
      //console.log(response)
      if (response.success) {
        localStorage.setItem('res_uid', response.data.res_id)
        localStorage.setItem('seat_allocated', response.data.max_guest_per_slot)
        localStorage.setItem('guest_per_booking', response.data.max_guest_per_booking)
        localStorage.setItem('force_update_pass', response.data.user.force_update_pass)
        if (response.data.user.res_name)
          this.requestApiService.setRestaurantInfoSubmitted(true);
        this.incorrect = false;
        this.message = response.message;
        this.messageservices.showNotification(response.msg, 'success', 'success');


        this.authService.setAuthInfo(response);
        if (response.data.user.res_name && this.isType == false) {
          this.router.navigate(['/dashboard']);
        } else if (this.isType) {
          this.router.navigate(['/booking-list']);
        } else {
          this.router.navigate(['/add-restaurant-info']);
        }
      } else {
        this.incorrect = true;
        this.message = response.message;
        //console.log(response.message);
        this.messageservices.showNotification(response.msg, 'error', 'error');
      }
    });
  }
  togglePwdType = () => {
    this.pwdType = !this.pwdType;
  }

}
